import React, { useContext } from 'react';
import { FormContext, FormSchemaFields } from '@sw-sw/lib-form';
import { UIControlType } from '@sw-sw/lib-form-control-types';
import FormModal from '../../Shared/form/modal/FormModal';
import { toast } from 'react-toastify';

interface FolderModalProps {
  show: boolean;
  isEdit: boolean;
  folder?: { id: number; name: string } | null;
  onClose: () => void;
  onSubmit: (folderData: { id?: number; name: string }) => Promise<void>;
  onDelete?: (folderId: number) => void;
}

const FolderModal: React.FC<FolderModalProps> = ({
  show,
  isEdit,
  folder,
  onClose,
  onSubmit,
  onDelete,
}) => {
  const formContext = useContext(FormContext);

  if (!show) return null;

  const handleSubmit = async (formData: any) => {
    if (!formData.name || formData.name.trim() === '') {
      toast.error('Folder name is required');
      return;
    }

    const folderData = {
      ...(isEdit && folder ? { id: folder.id } : {}),
      name: formData.name.trim(),
    };

    onSubmit(folderData);
  };

  const handleDelete = () => {
    if (folder && onDelete) {
      onDelete(folder.id);
    }
  };

  const getSchema = () => ({
    name: {
      label: 'Folder Name',
      type: UIControlType.text,
      required: true,
      placeholder: 'Enter folder name',
    },
  });

  return (
    <FormModal
      modalProps={{
        title: isEdit ? 'Edit Folder' : 'Create New Folder',
        submitBtnText: 'Submit',
      }}
      onSubmit={(formData) => handleSubmit(formData)}
      onCancel={onClose}
      showDelete={isEdit}
      onDelete={handleDelete}
    >
      <FormSchemaFields
        schema={getSchema()}
        onChange={formContext.set}
        formData={formContext.value}
        initialFormData={isEdit && folder ? { name: folder.name } : {}}
      />
    </FormModal>
  );
};

export default FolderModal;
